import { v } from '../koko-framework/shorthand'

export class GameTimeController {
    timeRemaining = 0;
    maxTime = 0;
    rank = 3;
    lastFrameStart = 0

    init(timeLimit) {
        this.rank = 3;
        this.timeRemaining = this.maxTime = timeLimit;
        this.lastFrameStart = 0;
        v.get('ingamehud').updateTimer(this.timeRemaining, this.maxTime);
    }

    update(frameStartTime) {
        let frameTime = 0;
        if (this.lastFrameStart > 0) {
            frameTime = frameStartTime - this.lastFrameStart;
        }
        this.lastFrameStart = frameStartTime;

        this.timeRemaining -= frameTime / 1000;
        if (this.timeRemaining < 0) {
            this.timeRemaining = 0;
        }
        let thirdTime = this.maxTime / 3;
        this.rank = Math.ceil(this.timeRemaining / thirdTime);
        if (this.rank < 1) {
            this.rank = 1;
        }
        v.get('ingamehud').updateTimer(this.timeRemaining, this.maxTime, this.rank);
    }

    pauseUpdate(frameStartTime) {
        this.lastFrameStart = frameStartTime;
    }
}